import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid2 as Grid,
  Stack,
  Typography,
} from "@mui/material";

import AdStatusBadge from "@/extensions/mediahouse/components/AdStatusBadge";
import { ObituaryMediaResponse } from "@/extensions/mediahouse/types";

interface OrderCardProps {
  data?: ObituaryMediaResponse;
}

const OrderCard: React.FC<OrderCardProps> = ({ data }) => {
  return (
    <Card
      sx={{
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "none",
        bgcolor: "background.paper",
      }}
    >
      <CardContent sx={{ p: 0 }}>
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          p={3}
        >
          <Typography component="h1" fontWeight={500} variant="h5">
            Orderinformation
          </Typography>
          <AdStatusBadge status={data?.status ?? "sent"} />
        </Stack>

        <Box sx={{ px: 3, pb: 3 }}>
          <Grid container spacing={3}>
            <Grid size={{ md: 4 }}>
              <Typography
                gutterBottom
                color="text.secondary"
                sx={{ mb: 1 }}
                variant="body2"
              >
                Ordernummer
              </Typography>
              <Typography variant="body1">
                {data?.order_reference ?? "—"}
              </Typography>
            </Grid>
            <Grid size={{ md: 4 }}>
              <Typography
                gutterBottom
                color="text.secondary"
                sx={{ mb: 1 }}
                variant="body2"
              >
                Införandedatum
              </Typography>
              <Typography variant="body1">
                {data?.publication_date ?? "—"}
              </Typography>
            </Grid>
            <Grid size={{ md: 4 }}>
              <Typography
                gutterBottom
                color="text.secondary"
                sx={{ mb: 1 }}
                variant="body2"
              >
                Publikation
              </Typography>
              <Typography variant="body1">
                {data?.publication.abbreviation ?? "—"}
              </Typography>
            </Grid>
          </Grid>

          <Divider sx={{ my: 4 }} />

          <Grid container spacing={3}>
            <Grid size={{ md: 4 }}>
              <Typography
                gutterBottom
                color="text.secondary"
                sx={{ mb: 1 }}
                variant="body2"
              >
                Beställare
              </Typography>
              <Typography variant="body1">{data?.office}</Typography>
            </Grid>
            <Grid size={{ md: 4 }}>
              <Typography
                gutterBottom
                color="text.secondary"
                sx={{ mb: 1 }}
                variant="body2"
              >
                Begravningsrådgivare
              </Typography>
              <Typography variant="body1">{data?.creator}</Typography>
            </Grid>
            <Grid size={{ md: 4 }}>
              <Typography
                gutterBottom
                color="text.secondary"
                sx={{ mb: 1 }}
                variant="body2"
              >
                Kontakt
              </Typography>
              <Typography sx={{ mb: 0.5 }} variant="body1">
                {/* TODO: Add tel here when backend is updated */}
                {data?.creator_email ?? "—"}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};

export default OrderCard;
